<template lang="pug">
.page
  header
    .max-width
      h1 Create Board
  section
    .max-width
      form(@submit.prevent="submit")
        AlertBox(v-if="error", type="danger", :text="error")

        .form-field(
          :class="{ error: $v.form.name.$error, 'error-required': !$v.form.name.required }"
        )
          label
            input(
              v-model="$v.form.name.$model",
              type="text",
              placeholder="Board Name"
            )
            //-.error(v-if="$v.form.name.$error && !$v.form.name.required") Field is required

        .form-field
          label
            textarea(
              v-model="form.description",
              placeholder="Board Description"
            )

        .form-field
          .row
            .col
              label.custom-select
                input(v-model="form.public", type="radio", :value="true")
                .custom-select-container
                  .row.center
                    .col
                      font-awesome-icon.icon(:icon="['fad', 'lock-open-alt']")
                    .col
                      h6 Public
                      p Allow anyone to access
            .col
              label.custom-select
                input(v-model="form.public", type="radio", :value="false")
                .custom-select-container
                  .row.center
                    .col
                      font-awesome-icon.icon(:icon="['fad', 'lock-alt']")
                    .col
                      h6 Private
                      p Limit to company members
        .form-field
          SubmitButton(label="Create", :formState="formState")
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'
import { form } from '@/mixins/form'

export default {
  name: 'CreateBoard',
  mixins: [form],
  beforeMount () {
  },
  data () {
    return {
      formState: 'initial',
      form: {
        name: '',
        description: '',
        public: true
      },
      error: null
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  computed: {
    ...mapGetters({
      public: 'boards/public',
      private: 'boards/private'
    })
  },
  methods: {
    submit () {

      //let allowed = this.$allowed(`board.${this.form.public ? 'public' : 'private'}`)
      //console.log(allowed)

      //if (this.$block(`plan.${this.form.public ? 'public' : 'private'}`, ))

      if (this.__formInvalid()) return

      this.formState = 'pending'

      this.$store.dispatch('boards/postBoard', this.form)
        .then((board) => {
          console.log(`result = `, board)
          this.$router.push({
            name: 'AdminBoard',
            params: {
              boardSlug: board.slug
            }
          })
        }, errors => {
          this.formState = 'initial'
          this.error = errors
          console.log(errors)
        })
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
